import { ColumnConfig, ColumnConfigOptions, ColumnText, EsgCarbonEmissionTransform, LodashSeriesEnricherMapper, NumberFormatter, StoreNestedFilterExtractor, TabConfig, TablePerPortfolioSeriesExtractorConfig } from '@ddt-web/data-service';

import { FAMILY_PERFORMANCE_COLUMN_CONFIG, MODEL_PORTFOLIO_FILTER_FUNCTION, MODEL_SHORT_NAME_COLUMN } from './family-column.config';

export const ESG_CARBON_INTENSITY = new TabConfig(
	'esg.carbonIntensity',
	null,
	new TablePerPortfolioSeriesExtractorConfig(
		new LodashSeriesEnricherMapper(
			['families', 'familyEsg'],
			['families', 'familyEsg'],
			'families.models',
			(portfolio: any, data: any) => {
				return {
					...portfolio,
					...data?.familyEsg?.models?.find(model => model?.id === portfolio.id) ?? []
				};
			},
			MODEL_PORTFOLIO_FILTER_FUNCTION
		),
		new ColumnText('MODEL', 'Model'),
		[
			ColumnConfig.create({
				id: 'esgScore',
				label: new ColumnText('ESG Score', 'ESG Score', null, { sortable: false, align: 'text-align-left' }),
				extractor: new StoreNestedFilterExtractor(
					[''],
					'esgScores',
					[{ propertyToCompare: 'name', comparedValue: 'carbonScore', desiredValueExpression: 'total' }]
				),
				labelFormatter: NumberFormatter.create({ defaultNullValue: NumberFormatter.DASH_VALUE })
			} as ColumnConfigOptions<StoreNestedFilterExtractor>),
			MODEL_SHORT_NAME_COLUMN,
			ColumnConfig.create({
				id: 'esgScoreBenchmark',
				label: new ColumnText('ESG Score Benchmark', 'ESG Score Benchmark', null, { sortable: false, align: 'text-align-left' }),
				extractor: new StoreNestedFilterExtractor(
					['familyEsg'],
					'benchmarkEsgScores',
					[{ propertyToCompare: 'name', comparedValue: 'carbonScore', desiredValueExpression: 'total' }]
				),
				labelFormatter: new NumberFormatter(NumberFormatter.PERCENT)
			} as ColumnConfigOptions<StoreNestedFilterExtractor>)
		],
		FAMILY_PERFORMANCE_COLUMN_CONFIG,
		null,
		new EsgCarbonEmissionTransform()
	)
);
